import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import Cookies from "js-cookie";

let baseURL =
  // window.location.origin === "https://corp.little.global"
  //   ? "https://corp.little.global/server"
  //   : "";
  // "http://localhost:4001";
  // "http://192.168.0.126:4001";
  // "https://littleinfinity.in:4001";
  
  "https://littleinfinity.in:4001";
const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(async (requestConfig, applyData) => {
    setIsLoading(true);
    setError(null);

    // Retrieve the authorization token (assuming it's stored in localStorage)
    // const token = localStorage.getItem("authToken");
    const token = Cookies.get("token");
    try {
      const response = await fetch(baseURL + requestConfig.url, {
        // method: requestConfig.method,
        method: requestConfig.method || "POST",
        // headers: requestConfig.headers,
        headers: {
          ...requestConfig.headers,
          "Content-Type": "application/json",
          // Authorization: token ? `Bearer ${token}` : "",
          Authorization: token ? token : "",
          "X-Requested-With": "XMLHttpRequest",
          "Strict-Transport-Security":
            "max-age=63072000; includeSubDomains; preload",
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "no-referrer",
        },
        // body: JSON.stringify(requestConfig.body),
        body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
      });

      if (!response.ok) {
        const errorMessage = await response.text(); // Get the response text for a better error message
        throw new Error(`Error: ${response.status} - ${errorMessage}`);
      }

      const data = await response.json();
      // Check if applyData is a function before calling it
      if (applyData && typeof applyData === "function") {
        applyData(data);
      }

      return data; // Optionally return data if needed
    } catch (err) {
      const message = err.message || "Something went wrong!";
      setError(message);
      if (applyData && typeof applyData === "function") {
        applyData(message);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    error,
    sendRequest,
  };
};

export default useHttp;
